import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';

import { SpaRoute, PermissionHelperService } from '@permission';

@Component({
  selector: 'spa-app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class NavigationComponent implements OnInit {
  private readonly permissionHelperService = inject(PermissionHelperService);

  routes = input<SpaRoute[]>([]);

  filteredRoutes = signal<SpaRoute[]>([]);

  itemIcons: Record<string, string> = {
    home: 'home',
    search: 'search',
    book: 'confirmation_number',
    'booking-treatments': 'local_activity',
    reports: 'content_copy',
    settings: 'settings',
    prepaid: 'upload_file',
    'ressource-config': 'tune',
  };

  async ngOnInit() {
    this.filteredRoutes.set(this.permissionHelperService.filterPermittedRoutes(this.routes(), ['**']));
  }
}
